import React from 'react';
import PropTypes from 'prop-types';

import { Color, colorList, FontSize, FontWeight } from '../../../typings/design-tokens';
import { IComponent } from '../../../typings/generic-component';
import { IClassNames, makeClassNames } from '../../../utils/styles';
import Text, { TextTags } from '../../atoms/text/text';
import './title.scss';

export interface ITitle extends IComponent {}

const DEFAULT_TITLE_TAG: TextTags = 'h3';
const DEFAULT_TITLE_COLOR: Color = 'red-light';

const TITLE_FONT_SIZE: FontSize = '16--14';
const TITLE_FONT_WEIGHT: FontWeight = '500';

const classNames = (): IClassNames =>
  makeClassNames({
    title: 'title',
  });

const Title: React.FC<ITitle> = ({
  /* istanbul ignore next: default value */ color = DEFAULT_TITLE_COLOR,
  children,
}) => {
  const cn = classNames();

  return (
    <Text
      className={cn.title}
      color={color}
      fontSize={TITLE_FONT_SIZE}
      fontWeight={TITLE_FONT_WEIGHT}
      tag={DEFAULT_TITLE_TAG}
    >
      {children}
    </Text>
  );
};

Title.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf(colorList),
};

export default Title;
